const _shoes = {
	'antique-boots': {
		name: 'antique boots',
		variations: {
			brown: 'Brown',
			black: 'Black',
			beige: 'Beige',
		},
	},
	'armor-shoes': {
		name: 'armor shoes',
		variations: {
			gray: 'Gray',
		},
	},
	babouches: {
		name: 'babouches',
		variations: {
			blue: 'Blue',
			orange: 'Orange',
			pink: 'Pink',
			yellow: 'Yellow',
			gray: 'Gray',
			purple: 'Purple',
			mint: 'Mint',
			red: 'Red',
		},
	},
	'ballet-slippers': {
		name: 'ballet slippers',
		variations: {
			pink: 'Pink',
			mint: 'Mint',
			blue: 'Blue',
			purple: 'Purple',
			black: 'Black',
			white: 'White',
			yellow: 'Yellow',
			red: 'Red',
		},
	},
	'basketball-shoes': {
		name: 'basketball shoes',
		variations: {
			red: 'Red',
			green: 'Green',
			beige: 'Beige',
			orange: 'Orange',
			blue: 'Blue',
			purple: 'Purple',
			'light-blue': 'Light blue',
			pink: 'Pink',
		},
	},
	'beaded-sandals': {
		name: 'beaded sandals',
		variations: {
			orange: 'Orange',
			purple: 'Purple',
			yellow: 'Yellow',
			red: 'Red',
			green: 'Green',
			beige: 'Beige',
		},
	},
	boots: {
		name: 'boots',
		variations: {
			green: 'Green',
			black: 'Black',
			blue: 'Blue',
			red: 'Red',
			olive: 'Olive',
		},
	},
	'business-shoes': {
		name: 'business shoes',
		variations: {
			black: 'Black',
			brown: 'Brown',
		},
	},
	cleats: {
		name: 'cleats',
		variations: {
			blue: 'Blue',
			'light-blue': 'Light blue',
			red: 'Red',
			yellow: 'Yellow',
			black: 'Black',
			orange: 'Orange',
			green: 'Green',
			purple: 'Purple',
		},
	},
	'comfy-sandals': {
		name: 'comfy sandals',
		variations: {
			brown: 'Brown',
			white: 'White',
			green: 'Green',
			blue: 'Blue',
			red: 'Red',
			orange: 'Orange',
			yellow: 'Yellow',
			purple: 'Purple',
		},
	},
	'cowboy-boots': {
		name: 'cowboy boots',
		variations: {
			brown: 'Brown',
			black: 'Black',
			ivory: 'Ivory',
			pink: 'Pink',
			blue: 'Blue',
		},
	},
	'cross-belt-sandals': {
		name: 'cross-belt sandals',
		variations: {
			green: 'Green',
			pink: 'Pink',
			gray: 'Gray',
			brown: 'Brown',
			black: 'Black',
			purple: 'Purple',
		},
	},
	'cute-sneakers': {
		name: 'cute sneakers',
		variations: {
			'light-blue': 'Light blue',
			green: 'Green',
			pink: 'Pink',
			yellow: 'Yellow',
			purple: 'Purple',
			blue: 'Blue',
		},
	},
	'dal-slippers': {
		name: 'DAL slippers',
		variations: {
			blue: 'Blue',
		},
	},
	'earth-egg-shoes': {
		name: 'earth-egg shoes',
		variations: {
			none: 'None',
		},
	},
	'embroidered-shoes': {
		name: 'embroidered shoes',
		variations: {
			red: 'Red',
			white: 'White',
			black: 'Black',
			blue: 'Blue',
		},
	},
	'faux-fur-ankle-booties': {
		name: 'faux-fur ankle booties',
		variations: {
			olive: 'Olive',
			beige: 'Beige',
			'ruby-red': 'Ruby red',
			'navy-blue': 'Navy blue',
		},
	},
	'faux-shearling-boots': {
		name: 'faux-shearling boots',
		variations: {
			beige: 'Beige',
			pink: 'Pink',
			green: 'Green',
			black: 'Black',
			gray: 'Gray',
		},
	},
	'faux-suede-sneakers': {
		name: 'faux-suede sneakers',
		variations: {
			green: 'Green',
			'navy-blue': 'Navy blue',
			beige: 'Beige',
			orange: 'Orange',
			pink: 'Pink',
			'light-blue': 'Light blue',
			purple: 'Purple',
			'berry-red': 'Berry red',
		},
	},
	'flip-flops': {
		name: 'flip-flops',
		variations: {
			blue: 'Blue',
			green: 'Green',
			yellow: 'Yellow',
			white: 'White',
			orange: 'Orange',
			'light-blue': 'Light blue',
			pink: 'Pink',
			red: 'Red',
		},
	},
	'flower-sandals': {
		name: 'flower sandals',
		variations: {
			yellow: 'Yellow',
			pink: 'Pink',
			green: 'Green',
			purple: 'Purple',
			blue: 'Blue',
			black: 'Black',
			white: 'White',
		},
	},
	'ghillie-brogues': {
		name: 'ghillie brogues',
		variations: {
			brown: 'Brown',
			black: 'Black',
			white: 'White',
		},
	},
	'gladiator-sandals': {
		name: 'gladiator sandals',
		variations: {
			brown: 'Brown',
			black: 'Black',
			red: 'Red',
		},
	},
	'gold-armor-shoes': {
		name: 'gold-armor shoes',
		variations: {
			gold: 'Gold',
		},
	},
	'hi-tech-sneakers': {
		name: 'hi-tech sneakers',
		variations: {
			orange: 'Orange',
			pink: 'Pink',
			green: 'Green',
			'light-blue': 'Light blue',
			blue: 'Blue',
		},
	},
	'high-tops': {
		name: 'high-tops',
		variations: {
			gray: 'Gray',
			brown: 'Brown',
			green: 'Green',
			blue: 'Blue',
			purple: 'Purple',
			red: 'Red',
			yellow: 'Yellow',
			white: 'White',
		},
	},
	'house-slippers': {
		name: 'house slippers',
		variations: {
			gray: 'Gray',
			'navy-blue': 'Navy blue',
			pink: 'Pink',
			yellow: 'Yellow',
			green: 'Green',
			blue: 'Blue',
			red: 'Red',
			beige: 'Beige',
		},
	},
	'jesters-shoes': {
		name: "jester's shoes",
		variations: {
			purple: 'Purple',
			black: 'Black',
			red: 'Red',
			green: 'Green',
		},
	},
	'kiddie-sneakers': {
		name: 'kiddie sneakers',
		variations: {
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			purple: 'Purple',
			silver: 'Silver',
			black: 'Black',
		},
	},
	'kimono-sandals': {
		name: 'kimono sandals',
		variations: {
			black: 'Black',
			red: 'Red',
			pink: 'Pink',
			'dark-blue': 'Dark blue',
			gray: 'Gray',
			purple: 'Purple',
			yellow: 'Yellow',
			green: 'Green',
		},
	},
	'kung-fu-shoes': {
		name: 'kung-fu shoes',
		variations: {
			black: 'Black',
		},
	},
	'labelle-pumps': {
		name: 'Labelle pumps',
		variations: {
			twilight: 'Twilight',
			midnight: 'Midnight',
			passion: 'Passion',
			ocean: 'Ocean',
			sunset: 'Sunset',
			love: 'Love',
		},
	},
	'labelle-sneakers': {
		name: 'Labelle sneakers',
		variations: {
			twilight: 'Twilight',
			midnight: 'Midnight',
			passion: 'Passion',
			ocean: 'Ocean',
			sunset: 'Sunset',
			love: 'Love',
		},
	},
	'lace-up-boots': {
		name: 'lace-up boots',
		variations: {
			black: 'Black',
			white: 'White',
			brown: 'Brown',
			red: 'Red',
		},
	},
	'leaf-egg-shoes': {
		name: 'leaf-egg shoes',
		variations: {
			none: 'None',
		},
	},
	'leopard-pumps': {
		name: 'leopard pumps',
		variations: {
			beige: 'Beige',
			gray: 'Gray',
			blue: 'Blue',
			green: 'Green',
			purple: 'Purple',
			pink: 'Pink',
		},
	},
	loafers: {
		name: 'loafers',
		variations: {
			brown: 'Brown',
			black: 'Black',
			white: 'White',
			pink: 'Pink',
			blue: 'Blue',
			yellow: 'Yellow',
			red: 'Red',
		},
	},
	'mages-booties': {
		name: "mage's booties",
		variations: {
			black: 'Black',
			blue: 'Blue',
			white: 'White',
			red: 'Red',
		},
	},
	'mary-janes': {
		name: 'mary janes',
		variations: {
			black: 'Black',
			red: 'Red',
			white: 'White',
			'light-blue': 'Light blue',
			yellow: 'Yellow',
			blue: 'Blue',
			green: 'Green',
			pink: 'Pink',
		},
	},
	'moccasin-boots': {
		name: 'moccasin boots',
		variations: {
			camel: 'Camel',
			olive: 'Olive',
			beige: 'Beige',
			pink: 'Pink',
			black: 'Black',
			blue: 'Blue',
			orange: 'Orange',
		},
	},
	moccasins: {
		name: 'moccasins',
		variations: {
			camel: 'Camel',
			red: 'Red',
			'light-blue': 'Light blue',
			white: 'White',
			pink: 'Pink',
			gray: 'Gray',
			black: 'Black',
		},
	},
	'nook-inc-slippers': {
		name: 'Nook Inc. slippers',
		variations: {
			white: 'White',
		},
	},
	'outdoor-sandals': {
		name: 'outdoor sandals',
		variations: {
			green: 'Green',
			red: 'Red',
			blue: 'Blue',
			purple: 'Purple',
			yellow: 'Yellow',
			orange: 'Orange',
			white: 'White',
			black: 'Black',
		},
	},
	'paw-slippers': {
		name: 'paw slippers',
		variations: {
			pink: 'Pink',
			brown: 'Brown',
			white: 'White',
			blue: 'Blue',
			black: 'Black',
		},
	},
	'pleather-ankle-booties': {
		name: 'pleather ankle booties',
		variations: {
			brown: 'Brown',
			black: 'Black',
			green: 'Green',
			mustard: 'Mustard',
		},
	},
	'pleather-sneakers': {
		name: 'pleather sneakers',
		variations: {
			white: 'White',
			black: 'Black',
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			yellow: 'Yellow',
			'light-blue': 'Light blue',
			orange: 'Orange',
		},
	},
	'pom-pom-boots': {
		name: 'pom-pom boots',
		variations: {
			pink: 'Pink',
			red: 'Red',
			yellow: 'Yellow',
			purple: 'Purple',
			green: 'Green',
			blue: 'Blue',
			black: 'Black',
		},
	},
	'power-boots': {
		name: 'power boots',
		variations: {
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			black: 'Black',
		},
	},
	'rain-boots': {
		name: 'rain boots',
		variations: {
			yellow: 'Yellow',
			green: 'Green',
			blue: 'Blue',
			purple: 'Purple',
			pink: 'Pink',
			red: 'Red',
			beige: 'Beige',
			black: 'Black',
		},
	},
	'recycled-boots': {
		name: 'recycled boots',
		variations: {
			brown: 'Brown',
		},
	},
	'restroom-slippers': {
		name: 'restroom slippers',
		variations: {
			'navy-blue': 'Navy blue',
			red: 'Red',
			green: 'Green',
			'light-blue': 'Light blue',
			pink: 'Pink',
		},
	},
	'ribbon-sandals': {
		name: 'ribbon sandals',
		variations: {
			blue: 'Blue',
			white: 'White',
			pink: 'Pink',
			yellow: 'Yellow',
			green: 'Green',
			'berry-red': 'Berry red',
			black: 'Black',
			beige: 'Beige',
		},
	},
	'rubber-toe-high-tops': {
		name: 'rubber-toe high tops',
		variations: {
			blue: 'Blue',
			olive: 'Olive',
			beige: 'Beige',
			pink: 'Pink',
			'berry-red': 'Berry red',
			coral: 'Coral',
			ivory: 'Ivory',
			black: 'Black',
		},
	},
	'rubber-toe-sneakers': {
		name: 'rubber-toe sneakers',
		variations: {
			purple: 'Purple',
			green: 'Green',
			yellow: 'Yellow',
			'light-blue': 'Light blue',
			red: 'Red',
			pink: 'Pink',
			blue: 'Blue',
			black: 'Black',
		},
	},
	'samurai-greaves': {
		name: 'samurai greaves',
		variations: {
			red: 'Red',
			black: 'Black',
			blue: 'Blue',
			white: 'White',
			'golden-yellow': 'Golden yellow',
		},
	},
	'shiny-bow-platform-shoes': {
		name: 'shiny bow platform shoes',
		variations: {
			pink: 'Pink',
			black: 'Black',
			red: 'Red',
			purple: 'Purple',
			'light-blue': 'Light blue',
			white: 'White',
			'light-purple': 'Light purple',
		},
	},
	'shower-sandals': {
		name: 'shower sandals',
		variations: {
			black: 'Black',
			white: 'White',
			gold: 'Gold',
			red: 'Red',
			blue: 'Blue',
		},
	},
	'ski-boots': {
		name: 'ski boots',
		variations: {
			white: 'White',
			orange: 'Orange',
			red: 'Red',
			lime: 'Lime',
			'light-blue': 'Light blue',
			purple: 'Purple',
		},
	},
	'sky-egg-shoes': {
		name: 'sky-egg shoes',
		variations: {
			none: 'None',
		},
	},
	'slip-on-loafers': {
		name: 'slip-on loafers',
		variations: {
			yellow: 'Yellow',
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			black: 'Black',
			'light-blue': 'Light blue',
			white: 'White',
			beige: 'Beige',
		},
	},
	'slip-on-sandals': {
		name: 'slip-on sandals',
		variations: {
			'light-blue': 'Light blue',
			lime: 'Lime',
			black: 'Black',
			pink: 'Pink',
			'navy-blue': 'Navy blue',
			red: 'Red',
			orange: 'Orange',
			purple: 'Purple',
		},
	},
	'slip-on-school-shoes': {
		name: 'slip-on school shoes',
		variations: {
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			yellow: 'Yellow',
			pink: 'Pink',
		},
	},
	slippers: {
		name: 'slippers',
		variations: {
			gray: 'Gray',
			black: 'Black',
			white: 'White',
			pink: 'Pink',
			green: 'Green',
			blue: 'Blue',
			red: 'Red',
			yellow: 'Yellow',
		},
	},
	'space-boots': {
		name: 'space boots',
		variations: {
			white: 'White',
		},
	},
	'sporty-sandals': {
		name: 'sporty sandals',
		variations: {
			red: 'Red',
			olive: 'Olive',
			blue: 'Blue',
			purple: 'Purple',
			green: 'Green',
			pink: 'Pink',
			beige: 'Beige',
			gray: 'Gray',
		},
	},
	'steel-toed-boots': {
		name: 'steel-toed boots',
		variations: {
			brown: 'Brown',
			beige: 'Beige',
			green: 'Green',
			black: 'Black',
			red: 'Red',
			gray: 'Gray',
		},
	},
	'stone-egg-shoes': {
		name: 'stone-egg shoes',
		variations: {
			none: 'None',
		},
	},
	'strappy-heels': {
		name: 'strappy heels',
		variations: {
			red: 'Red',
			blue: 'Blue',
			gold: 'Gold',
			silver: 'Silver',
			black: 'Black',
			pink: 'Pink',
			green: 'Green',
			purple: 'Purple',
		},
	},
	'traditional-flower-shoes': {
		name: 'traditional flower shoes',
		variations: {
			red: 'Red',
			pink: 'Pink',
			blue: 'Blue',
			yellow: 'Yellow',
			lime: 'Lime',
		},
	},
	'trekking-shoes': {
		name: 'trekking shoes',
		variations: {
			orange: 'Orange',
			gray: 'Gray',
			black: 'Black',
			'light-blue': 'Light blue',
			yellow: 'Yellow',
			purple: 'Purple',
			white: 'White',
			brown: 'Brown',
		},
	},
	'velour-boots': {
		name: 'velour boots',
		variations: {
			'ruby-red': 'Ruby red',
			gray: 'Gray',
			brown: 'Brown',
			blue: 'Blue',
			mustard: 'Mustard',
		},
	},
	'vinyl-round-toed-pumps': {
		name: 'vinyl round-toed pumps',
		variations: {
			beige: 'Beige',
			mint: 'Mint',
			brown: 'Brown',
			pink: 'Pink',
			white: 'White',
			black: 'Black',
		},
	},
	'visual-punk-boots': {
		name: 'visual-punk boots',
		variations: {
			black: 'Black',
		},
	},
	'walking-shoes': {
		name: 'walking shoes',
		variations: {
			pink: 'Pink',
			beige: 'Beige',
			red: 'Red',
		},
	},
	'water-sandals': {
		name: 'water sandals',
		variations: {
			pink: 'Pink',
			'navy-blue': 'Navy blue',
			red: 'Red',
			'light-blue': 'Light blue',
			orange: 'Orange',
			purple: 'Purple',
			green: 'Green',
			yellow: 'Yellow',
		},
	},
	'water-shoes': {
		name: 'water shoes',
		variations: {
			pink: 'Pink',
			'light-blue': 'Light blue',
			orange: 'Orange',
			green: 'Green',
			'navy-blue': 'Navy blue',
			yellow: 'Yellow',
			red: 'Red',
			black: 'Black',
		},
	},
	'water-egg-shoes': {
		name: 'water-egg shoes',
		variations: {
			none: 'None',
		},
	},
	'wingtip-shoes': {
		name: 'wingtip shoes',
		variations: {
			'black-and-white': 'Black & white',
			brown: 'Brown',
			greige: 'Greige',
			green: 'Green',
			gray: 'Gray',
			'berry-red': 'Berry red',
			black: 'Black',
		},
	},
	winklepickers: {
		name: 'winklepickers',
		variations: {
			red: 'Red',
			white: 'White',
			black: 'Black',
			blue: 'Blue',
		},
	},
	'wood-egg-shoes': {
		name: 'wood-egg shoes',
		variations: {
			none: 'None',
		},
	},
	'wooden-clogs': {
		name: 'wooden clogs',
		variations: {
			yellow: 'Yellow',
			blue: 'Blue',
			red: 'Red',
			green: 'Green',
			brown: 'Brown',
		},
	},
	'work-boots': {
		name: 'work boots',
		variations: {
			red: 'Red',
			purple: 'Purple',
			pink: 'Pink',
			yellow: 'Yellow',
			white: 'White',
			blue: 'Blue',
			green: 'Green',
			gray: 'Gray',
		},
	},
	'wrestling-shoes': {
		name: 'wrestling shoes',
		variations: {
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			pink: 'Pink',
			black: 'Black',
			yellow: 'Yellow',
		},
	},
	'zap-boots': {
		name: 'zap boots',
		variations: {
			white: 'White',
		},
	},
	zori: {
		name: 'zori',
		variations: {
			black: 'Black',
			gold: 'Gold',
			pink: 'Pink',
			'light-pink': 'Light pink',
			green: 'Green',
			white: 'White',
			aqua: 'Aqua',
			red: 'Red',
		},
	},
};

export { _shoes };
